// extracted by mini-css-extract-plugin
var _1 = "NavigationButtonsDemo_buttonWrapper__94964";
var _2 = "NavigationButtonsDemo_demo__8a335";
var _3 = "NavigationButtonsDemo_empty__09453";
var _4 = "NavigationButtonsDemo_item__05cd9";
var _5 = "NavigationButtonsDemo_text__a532d";
var _6 = "NavigationButtonsDemo_visible__abf2d";
export { _1 as "buttonWrapper", _2 as "demo", _3 as "empty", _4 as "item", _5 as "text", _6 as "visible" }
